/**
 * Pebble Configurator - Multi-Pendant Version
 * Handles multiple pendant rows, dynamic pricing, and bulk cart addition.
 */

/* --- Helper: Find variant by matching Chain Length and the Type-Size-Material string --- */
function findVariantByOptions(variants, values) {
  if (!variants || !Array.isArray(variants)) return null;
  
  // Normalize search values (e.g., "45cm" and "Birthstone-Medium-Silver")
  const searchValues = values.map(v => v.toString().replace(/\s+/g, '').toLowerCase());

  return variants.find(variant => {
    if (!variant.options) return false;
    const variantOptions = variant.options.map(opt => opt.toString().replace(/\s+/g, '').toLowerCase());
    
    // Check if both required strings exist in this variant's options
    return searchValues.every(sv => variantOptions.includes(sv));
  }) || null;
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('pebble-config-container');
  const submitButton = document.querySelector('button[name="add"]');
  const totalPriceEl = document.getElementById('config-total-price');
  
  if (!container) return;

  /**
   * Recalculates the total price based on selected pendants and chain length.
   */
function recalc() {
    const rows = container.querySelectorAll('.pebble-row');

    const chainLengthInput = document.querySelector('input[name="Global-Chain-Length"]:checked');
    let chainLength = chainLengthInput ? chainLengthInput.value : '45cm';

    let totalCents = 0;
    let allValid = rows.length > 0;
    const selectedItems = []; 
    
    let isFirstValidPendant = true;
    const configGroupId = Date.now().toString();

    rows.forEach(row => {
      const type = row.querySelector('[name$="-type"]:checked')?.value;
      const size = row.querySelector('[name$="-size"]:checked')?.value;
      const material = row.querySelector('[name$="-material"]:checked')?.value;

      // --- NEW: Strict Validation for Inputs ---
      let initialVal = '';
      let stoneVal = '';
      let hasRequiredDetails = true;

      if (type === 'Letter') {
        // Grab the input, trim whitespace, and check if it's empty
        initialVal = row.querySelector('[name$="-letter"]')?.value?.trim().toUpperCase() || '';
        if (initialVal === '') hasRequiredDetails = false;
      } else if (type === 'Birthstone') {
        stoneVal = row.querySelector('[name$="-stone"]')?.value || '';
        if (stoneVal === '') hasRequiredDetails = false;
      }

      // Ensure Type, Size, Material AND the specific details are filled out
      if (type && size && material && hasRequiredDetails) {
        const searchString = `${type}-${size}-${material}`; 

        let variant = findVariantByOptions(window.PRODUCT_MAP.variants, [type, size, material]);
        
        if (!variant) {
          variant = findVariantByOptions(window.PRODUCT_MAP.variants, [searchString]);
        }        
        
        if (variant) {
          totalCents += variant.price;
          
          const props = {};
          props['_group'] = configGroupId;

          // Add Initial or Stone to properties
          if (type === 'Letter') {
            props['Initial'] = initialVal;
          } else if (type === 'Birthstone') {
            props['Stone'] = stoneVal;
          }
          
          if (isFirstValidPendant) {
            props['Chain Length'] = chainLength;
            props['_is_base'] = 'true'; 
            isFirstValidPendant = false; 
          } else {
            props['_Chain Length'] = chainLength;
          }

          selectedItems.push({
            id: variant.id,
            quantity: 1,
            properties: props
          });
          
        } else {
          allValid = false;
        }
      } else {
        allValid = false; // Fails validation if dropdowns or inputs are empty
      }
    });

    if (totalPriceEl) {
      if (allValid) {
        totalPriceEl.textContent = `R ${(totalCents / 100).toFixed(2)}`;
      } else {
        totalPriceEl.textContent = rows.length === 0 ? 'Add a pendant to start' : 'Select Initial or Birthstone';
      }
    }

    // --- NEW: Physically disable/enable the Add to Cart button ---
    const submitBtn = document.querySelector('button[name="add"]');
    if (submitBtn) {
      submitBtn.disabled = !allValid;
    }

    if (typeof updateButtonState === 'function') {
        updateButtonState(allValid, rows.length);
    }

    return { items: selectedItems, allValid, chainLength };
  }

  /**
   * Updates the button UI. 
   * Separated so it can be called by the observer to prevent intermittent "Sold Out" text.
   */
  function updateButtonState(allValid, rowCount) {
    if (!submitButton) return;
    const buttonText = submitButton.querySelector('span');
    
    if (allValid) {
      submitButton.removeAttribute('disabled');
      submitButton.style.opacity = '1';
      if (buttonText) buttonText.textContent = 'Add to cart';
    } else {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.style.opacity = '0.5';
      if (buttonText) {
        buttonText.textContent = rowCount === 0 ? 'Select configuration' : 'Incomplete';
      }
    }
  }

  /**
   * MUTATION OBSERVER
   * Themes often reset the button text to "Sold Out" when they detect variant changes.
   * This observer watches the button and forces our text back on top if it changes.
   */
  if (submitButton) {
    const observer = new MutationObserver(() => {
        const rows = container.querySelectorAll('.pebble-row');
        const type = rows[0]?.querySelector('[name$="-type"]:checked')?.value;
        const size = rows[0]?.querySelector('[name$="-size"]:checked')?.value;
        const mat = rows[0]?.querySelector('[name$="-material"]:checked')?.value;
        const allValid = rows.length > 0 && !!(type && size && mat);
        
        // Temporarily disconnect to avoid infinite loop when we change the text ourselves
        observer.disconnect();
        updateButtonState(allValid, rows.length);
        observer.observe(submitButton, { childList: true, subtree: true, characterData: true });
    });
    
    observer.observe(submitButton, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('change', (e) => {
    const isChainInput = e.target.name?.includes('Chain Length') || 
                        e.target.value === '45cm' || 
                        e.target.value === '50cm';
    if (isChainInput) {
      recalc();
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.tagName === 'INPUT' && (e.target.value === '45cm' || e.target.value === '50cm')) {
      setTimeout(recalc, 50);
    }
  });

  const style = document.createElement('style');
  style.innerHTML = `
    .price, .product__tax, .product-variant-id { display: none !important; }
    variant-radios fieldset:nth-of-type(1), .product-form__input:nth-of-type(1) { display: none !important; }
    .pebble-row { 
      border: 1px solid rgba(var(--color-foreground), 0.1); 
      padding: 1.5rem; margin-bottom: 1.5rem; border-radius: 8px; 
      background: rgba(var(--color-foreground), 0.03); position: relative;
    }
    .remove-pebble {
      position: absolute; top: 10px; right: 10px; cursor: pointer; background: rgb(var(--color-foreground)); color: white;
      border: none; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
    }
    .pebble-row .custom-pills input[type="radio"] { display: none; }
    .pebble-row .custom-pills label {
      display: inline-block; padding: 6px 14px; margin: 4px 4px 4px 0;
      border: 1px solid rgba(var(--color-foreground), 0.2); border-radius: 6px; cursor: pointer; font-size: 1.2rem;
    }
    .pebble-row .custom-pills input:checked + label {
      background: rgb(var(--color-foreground)); color: rgb(var(--color-background));
    }
    .add-pendant-btn {
      margin: 1rem 0 2rem 0; width: 100%; padding: 1.2rem; border: 2px dashed rgba(var(--color-foreground), 0.3);
      background: none; cursor: pointer; border-radius: 8px; font-weight: bold;
    }
    .pebble-row select, .pebble-row input[type="text"] {
        width: 100%; padding: 8px; border: 1px solid rgba(var(--color-foreground), 0.2); border-radius: 4px; margin-top: 5px; color: rgb(var(--color-foreground), 0.8); font-weight: 600;
    }

     
  `;
  document.head.appendChild(style);

  function addPendantRow() {
    const id = Date.now();
    const html = `
      <div class="pebble-row" data-id="${id}">
        <button type="button" class="remove-pebble">✕</button>
        <div style="margin-bottom: 1rem;">
          <label class="form__label">Pendant Type</label>
          <div class="custom-pills">
            <input type="radio" name="p-${id}-type" value="Letter" id="p-${id}-type-l" checked><label for="p-${id}-type-l">Letter</label>
            <input type="radio" name="p-${id}-type" value="Birthstone" id="p-${id}-type-b"><label for="p-${id}-type-b">Birthstone</label>
          </div>
        </div>
        <div style="margin-bottom: 1rem;">
          <label class="form__label">Pendant Size</label>
          <div class="custom-pills">
            <input type="radio" name="p-${id}-size" value="Small" id="p-${id}-size-s" checked><label for="p-${id}-size-s">Small</label>
            <input type="radio" name="p-${id}-size" value="Medium" id="p-${id}-size-m"><label for="p-${id}-size-m">Medium</label>
            <input type="radio" name="p-${id}-size" value="Large" id="p-${id}-size-l"><label for="p-${id}-size-l">Large</label>
          </div>
        </div>
        <div style="margin-bottom: 1rem;">
          <label class="form__label">Material</label>
          <div class="custom-pills">
            <input type="radio" name="p-${id}-material" value="Silver" id="p-${id}-mat-s" checked><label for="p-${id}-mat-s">Silver</label>
            <input type="radio" name="p-${id}-material" value="Bronze" id="p-${id}-mat-b"><label for="p-${id}-mat-b">Bronze</label>
          </div>
        </div>
        <div class="pebble-letter-group" style="display:block; margin-top: 1rem;">
          <input type="text" name="p-${id}-letter" maxlength="1" placeholder="Initial" >
        </div>
        <div class="pebble-stone-group" style="display:none; margin-top: 1rem;">
          <select name="p-${id}-stone">
            <option value="">-- Select Stone --</option>
            <option value="Jan - Garnet">Jan - Garnet - Protection, strength & vitality</option>
            <option value="Feb - Amethyst">Feb - Amethyst - Balance, peace & mental clarity</option>
            <option value="Mar - Aquamarine">Mar - Aquamarine - Tranquility, courage & calm</option>
            <option value="Apr - Lab-Diamond">Apr - Lab-Diamond - Strength, eternal love & purity</option>
            <option value="May - Lab-Emerald">May - Lab-Emerald - Growth, prosperity & rebirth</option>
            <option value="Jun - Moonstone">Jun - Moonstone - emotional balance, intuition & ease stress</option>
            <option value="Jul - Lab-Ruby">Jul - Lab-Ruby - Passion, energy & vitality</option>
            <option value="Aug - Peridot">Aug - Peridot - Harmony, good fortune & protection</option>
            <option value="Sep - Lab-Sapphire">Sep - Lab-Sapphire - Wisdom, loyalty & truth</option>
            <option value="Oct - Pink Tourmaline">Oct - Pink Tourmaline - Love, compassion & emotional healing</option>
            <option value="Nov - Citrine">Nov - Citrine - Positivity, abundance & joy</option>
            <option value="Dec - Blue Topaz">Dec - Blue Topaz - Peace, communication & good luck</option>
          </select>
        </div>
      </div>
    `;
    container.insertAdjacentHTML('beforeend', html);
    const row = container.lastElementChild;
    row.querySelectorAll('[name$="-type"]').forEach(radio => {
      radio.addEventListener('change', (e) => {
        row.querySelector('.pebble-letter-group').style.display = e.target.value === 'Letter' ? 'block' : 'none';
        row.querySelector('.pebble-stone-group').style.display = e.target.value === 'Birthstone' ? 'block' : 'none';
        recalc();
      });
    });
    row.querySelectorAll('input, select').forEach(el => el.addEventListener('input', recalc));
    row.querySelector('.remove-pebble').addEventListener('click', () => { row.remove(); recalc(); });
    recalc();
  }

// 1. Add the very first row on page load
  addPendantRow();

  // 2. Create and insert the "+ Add Another Pendant" button
  const addBtn = document.createElement('button');
  addBtn.type = 'button';
  addBtn.className = 'add-pendant-btn';
  addBtn.textContent = '+ Add Another Pendant';
  addBtn.onclick = addPendantRow;
  container.after(addBtn);

  // 3. Listen for changes on the new chain length buttons to update prices
  document.querySelectorAll('input[name="Global-Chain-Length"]').forEach(input => {
    input.addEventListener('change', recalc);
  });

  // 4. Handle the Add to Cart submission
// 4. Handle the Add to Cart submission
  if (submitButton) {
    // 🚨 CRITICAL FIX: Change the button type from 'submit' to 'button'.
    // This makes Dawn's native product-form.js completely ignore the click, preventing clashes!
    submitButton.type = 'button';

submitButton.addEventListener('click', async (e) => {
      const { items, allValid } = recalc();
      if (!allValid || items.length === 0) return;
      
      e.preventDefault();
      e.stopImmediatePropagation();

      submitButton.classList.add('loading');
      
try {
        const cartDrawer = document.querySelector('cart-drawer');
        
        // 1. Get the exact sections Dawn needs, formatted as a comma-separated string
        let sectionsString = 'cart-drawer,cart-icon-bubble';
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          sectionsString = cartDrawer.getSectionsToRender().map(s => s.section || s.id).join(',');
        }

        // 2. Package the items AND the HTML request in one single payload
        const body = JSON.stringify({
          items: items,
          sections: sectionsString, 
          sections_url: window.location.pathname
        });

        // 3. Send the master request
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body
        });

        const parsedState = await response.json();

if (response.ok) {
          // 4. Because we asked for sections in the POST request, Shopify returns them perfectly synced!
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections) {
            
            // Hand the freshly minted, fully-populated HTML directly to Dawn
            cartDrawer.renderContents(parsedState);
            
            // 🚨 CRITICAL FIX: Manually remove the 'is-empty' class so Dawn's accessibility script doesn't crash!
            cartDrawer.classList.remove('is-empty');
            
            // Force the drawer to slide open visually
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('active', 'is-active');
            }
          } else {
            // Safety fallback
            window.location.href = '/cart'; 
          }
        } else {
          console.error("Error adding configuration to cart:", parsedState);
        }
      } catch (err) {
        console.error("Fetch error:", err);
      } finally {
        submitButton.classList.remove('loading');
      }
    });
  }
});